import React from 'react';
import { TableCell, TableRow, Tooltip } from '@material-ui/core';
import { useSyles } from './home.styles';
import { fullTime, mediumDate, mediumTime } from 'src/helpers/datetime';

const Row = ({ row }: { row: any }) => {
  const classes = useSyles();
  const { loan_id, users_name, users_id, complete_return_date } = row || {};

  return (
    <TableRow key={loan_id} className={classes.tableRow}>
      <TableCell component='th' scope='row'>
        {loan_id}
      </TableCell>
      <TableCell>{`${users_name} (${users_id})`}</TableCell>
      <TableCell>
        <div className={classes.datetime}>
          <Tooltip
            title={fullTime(complete_return_date)}
            aria-label={fullTime(complete_return_date)}
          >
            <div>
              {mediumDate(complete_return_date, '-')}{' '}
              {mediumTime(complete_return_date, '-')}
            </div>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default Row;
